<template>
  <div class="container">
    <div class="row">
      <h3>{{ $t("configure-password") }}</h3>

      <b-col cols="12">
        <b-alert variant="primary" :show="alert.length > 0">{{
          alert
        }}</b-alert>
      </b-col>

      <b-form v-if="userid" class="mb-5" @submit.prevent="onSubmit">
        <b-row
          v-for="(row, index) in combinedFormRows"
          :key="index"
          class="ms-0 ms-0"
        >
          <form-element
            v-for="formElement in row"
            :key="formElement.name"
            v-model="form[formElement.name]"
            :form-element="formElement"
          />
        </b-row>
        <b-row class="ms-0 mt-2">
          <b-col cols="12">
            <b-button type="submit" variant="primary" :disabled="disableForm">{{
              $t("submit")
            }}</b-button>
          </b-col>
          <b-col cols="12">
            <b-alert variant="info" class="mt-3" :show="message.length">{{
              message
            }}</b-alert>
          </b-col>
        </b-row>
      </b-form>
    </div>
  </div>
</template>

<script>
import formElement from "../form/FormElement.vue"
import formElements from "./configurePasswordFormElements"
import { BForm, BCol, BRow, BButton, BAlert } from "bootstrap-vue"

export default {
  components: {
    "form-element": formElement,
    BForm,
    BCol,
    BRow,
    BButton,
    BAlert,
  },
  data() {
    return {
      form: {},
      disableForm: false,
      message: "",
      alert: "",
      userid: null,
      code: null,
    }
  },
  computed: {
    combinedFormRows: function () {
      return formElements
    },
  },
  created() {
    this.userid = new URLSearchParams(window.location.search).get("UserID")
    this.code = new URLSearchParams(window.location.search).get("Code")

    if (this.userid === null) {
      this.alert = this.$t("thePasswordLinkIsInvalidOrHasExpired")
    }
  },

  methods: {
    onSubmit: async function () {
      // eslint-disable-next-line no-undef
      const result = await State.updatePassword(
        null,
        this.userid,
        this.code,
        this.form.Password,
        this.form.PasswordConfirmation
      )

      if (result.IsSucces) {
        this.alert = this.$t("passwordChanged")
        this.disableForm = true
      } else {
        this.alert = this.$t("somethingWentWrong")
      }
    },
  },
}
</script>
